import { api, ApiError } from '../api.js';
import { auth } from '../auth.js';
import { escape } from './form.js';

/**
 * Non-blocking banner that prompts unverified users to verify their email.
 * Shows on every authed page; cash flows are hard-gated on the backend by
 * the `require_verified_email` dependency.
 */
export function renderVerificationBanner(host) {
  const me = auth.getMe();
  if (!auth.isAuthenticated() || (me && me.email_verified)) {
    host.innerHTML = '';
    return;
  }

  host.innerHTML = `
    <div class="banner-wrap">
      <div class="banner" id="verify-banner">
        <span>📬 Verify your email to unlock cash games and withdrawals.</span>
        <span class="banner-actions">
          <a href="/verify-email" data-link>Verify now</a>
          <button type="button" class="link-button" id="resend-from-banner">Resend email</button>
        </span>
        <span class="banner-status" id="resend-banner-status"></span>
      </div>
    </div>
  `;

  const button = host.querySelector('#resend-from-banner');
  const status = host.querySelector('#resend-banner-status');
  button?.addEventListener('click', async () => {
    if (!me?.email) {
      status.textContent = "We couldn't find your email locally — log in again.";
      return;
    }
    button.disabled = true;
    status.textContent = 'Sending…';
    try {
      await api('/auth/resend-verification', {
        method: 'POST',
        body: { email: me.email },
      });
      status.textContent = 'Sent. Check your inbox.';
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Could not resend.';
      status.textContent = escape(msg);
    } finally {
      button.disabled = false;
    }
  });
}
